<script setup lang="ts">
import type { Question } from '../calendarQuestion'
import CalendarQuestionSampleSelectBox from './CalendarQuestionSampleSelectBox.vue'
import CalendarQuestionSampleText from './CalendarQuestionSampleText.vue'

const { question, formError } = defineProps<{
  question: Question
  formError: string | undefined
}>()
</script>
<template>
  <CalendarQuestionSampleText
    v-if="question.type === 'TEXT'"
    :question="question"
    :formError="formError"
  />
  <CalendarQuestionSampleSelectBox
    v-else-if="question.type === 'SELECT_BOX'"
    :question="question"
    :formError="formError"
  />
</template>
